﻿/*global $, $html, PersonCard, PersonResearch, addWebLinkModal, afterBelay, beforeBelay, checkNotesAndComments, closeCallouts, closeMyCanvasGuidance, console, enableOrDisableWebLinkAddOrSaveButton, factsTogglingCheckMark, getPersonAjaxUrlPrefix, initializeMobileTabs, initiateWebLinkValidator, loadUIState, newFactEditModal, notifyRecordObject, personPageAvailability, personViewModalAlertSettingsInfo, personViewModalAlertSettingsNote, personViewModalAlertSettingsSuccess, personViewModalAlertSettingsWarning, quickEdit, removeCitation, removeSource, removeWebLink, saveUIState, saveWebLink, setTimeout, sourceEditModal, toggleCheckedMenuItem, toggleShowAlternateEvents, toggleShowFamilyEvents, toggleShowHistoricalInsights, updateFactEditGenderRadio, window */
/****************************************
	person-view-facts.js
*****************************************/
/* Globals */
var factsTogglingCheckMark = false;
/* Saves the UI selection and position. */
function saveUIState(selection, stateData) {
	'use strict';
	var $selection,
		selector;
	if (selection !== undefined) {
		$selection = selection;
		if ($selection.length > 0) {
			selector = $selection.attr('id');
			if (selector) {
				selector = '#' + selector;
			} else {
				selector = $selection.attr('class');
				if (selector) {
					selector = '.' + selector;
				}
			}
		}
		if ($selection !== null && $selection.length && selector !== null) {
			var state = {
				'selection-id': selector,
				'selection-rect': $selection[0].getBoundingClientRect(),
				'selection-offset': $selection.offset()
			};
			if (stateData) {
				$.extend(state, { 'state-data': stateData });
			}
			$html.data(state);
		}
	}
}
/* Loads the saved UI selection and position. */
function loadUIState(triggerEvent, setScrollPosition) {
	'use strict';
	/* Reposition scrollbar on glue refresh caused from an event save or an event hide */
	var stateData;
	updateFamilyMemberStyles();
	if ($html.data('selection-id')) {
		var selection = {
			'id': $html.data('selection-id'),
			'$el': $($html.data('selection-id')),
			'rect': $html.data('selection-rect'),
			'offset': $html.data('selection-offset')
		};
		if ($html.data('state-data')) {
			stateData = $html.data('state-data');
		}
		if (selection.$el.length) {
			if (setScrollPosition) {
				/* Move scrollbar to position of where element is after reload. */
				$html.scrollTop(selection.$el.offset().top - selection.rect.top);
			}
			/* Trigger specified event on selection or focus. */
			selection.$el.trigger(triggerEvent || 'focus');
			$('.' + $html.data('saved-event-id')).focus();
		} else if (setScrollPosition) {
			/* Move scrollbar to position of where element was before reload. */
			$html.scrollTop(selection.offset.top - selection.rect.top);
		}
		/* Clear data */
		$html
			.removeData('selection-id')
			.removeData('selection-rect')
			.removeData('selection-offset')
			.removeData('state-data');
		return stateData;
	}
}
/* Toggle Show Family Events */
function toggleShowFamilyEvents(treeId, personId) {
	'use strict';
	var needToSaveState = $('.factItemSelected').length === 1;
	if (needToSaveState) {
		saveUIState($('.factItemSelected'));
	}
	personPageAvailability('Facts');
	toggleCheckedMenuItem('.toggleFamilyEvents');
	/* Make jquery call back to PersonController to toggle the setting */
	var toggleUrl = getPersonAjaxUrlPrefix() + '/tree/' + treeId + '/person/' + personId + '/tab/facts/toggleShowFamilyEvents';
	$.ajax({
		url: toggleUrl,
		method: 'GET',
		cache: false,
		success: function () {
			window.glue.reload(function () {
				personPageAvailability('Facts');
				if (needToSaveState) {
					loadUIState('belay.on');
				}
			});
		}
	});
}
/* Toggle Show Alternate Events */
function toggleShowAlternateEvents(treeId, personId) {
	'use strict';
	var needToSaveState = ($('.factItemSelected:not(.factItemAlternate)').length === 1);
	if (needToSaveState) {
		saveUIState($('.factItemSelected'));
	}
	personPageAvailability('Facts');
	toggleCheckedMenuItem('.toggleAlternates');
	/* Make jquery call back to PersonController to toggle the setting */
	var toggleUrl = getPersonAjaxUrlPrefix() + '/tree/' + treeId + '/person/' + personId + '/toggleShowAlternateEvents';
	$.ajax({
		url: toggleUrl,
		method: 'GET',
		cache: false,
		success: function () {
			window.glue.reload(function () {
				personPageAvailability('Facts');
				if (needToSaveState) {
					loadUIState('belay.on');
				}
			});
		}
	});
}
/* Toggle Show Historical Insights */
function toggleShowHistoricalInsights(treeId, personId) {
	'use strict';
	var needToSaveState = $('.factItemSelected').length === 1;
	personPageAvailability('Facts');
	if (needToSaveState) {
		saveUIState($('.factItemSelected'));
	}
	toggleCheckedMenuItem('.toggleHistoricalInsights');
	/* Make jquery call back to PersonController to toggle the setting */
	var toggleUrl = getPersonAjaxUrlPrefix() + '/tree/' + treeId + '/person/' + personId + '/tab/facts/toggleShowHistoricalInsights';
	$.ajax({
		url: toggleUrl,
		method: 'GET',
		cache: false,
		success: function () {
			window.glue.reload(function () {
				personPageAvailability('Facts');
				if (needToSaveState) {
					loadUIState('belay.on');
				}
			});
		}
	});
}
/* Update gender radio selection */
function updateFactEditGenderRadio(fieldChecked) {
	'use strict';
	var $button = $('.tabActive').find('#' + fieldChecked);
	if ($button.length > 0) {
		$button.prop('checked', true);
	}
}
/* Remove a person citation from person */
function removeCitation(citationId) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/citation/' + citationId + '/removecitation';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (data.result) {
				var needToSaveState = $('.factItemSelected').length === 1;
				if (needToSaveState) {
					saveUIState($('.factItemSelected'));
				}
				window.glue.reload(function () {
					if (needToSaveState) {
						loadUIState('belay.on');
					}
				});
				closeCallouts();
				$.modal.close();
			}
		}
	});
}
/* Remove a source */
function removeSource(sourceId) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/source/' + sourceId + '/removesource';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (data.result) {
				var needToSaveState = $('.factItemSelected').length === 1;
				if (needToSaveState) {
					saveUIState($('.factItemSelected'));
				}
				window.glue.reload(function () {
					if (needToSaveState) {
						loadUIState('belay.on');
					}
				});
				closeCallouts();
				$.modal.close();
			}
		}
	});
}
/* Initiate WebLInk Validator */
function initiateWebLinkValidator() {
	'use strict';
	$('#modalWebLinks').validator({
		'fields': {
			'webAddressInput': { 'pattern': 'url' }
		}
	});
}
/* Add weblink modal */
function addWebLinkModal() {
	'use strict';
	var $addWebLinkModalTrigger = $('.openWebLinkModal.card');
	if ($('.callout.open')) {
		$addWebLinkModalTrigger = $('.openWebLinkModal:not(.card)');
	}
	$('<div>').modal({
		'showLoading': true,
		'$trigger': $addWebLinkModalTrigger,
		'width': '510',
		'onOpen': function ($this) {
			var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/addweblink';
			$.ajax({
				type: 'GET',
				url: url,
				cache: false,
				timeout: 20000,
				success: function (data) {
					$.modal.showLoading(false);
					if (data.result) {
						$this.html(
							'<div class="modalHasTitle">' +
							'<div class="modalHeader">' +
							'<h4 class="modalTitle">' + PersonResearch.text.addWebLink + '</h4>' +
							'</div>' +
							data.html +
							'</div>'
						);
						/* Initialize Alerts */
						$('#modal')
							.find('.alertNote')
							.alert(personViewModalAlertSettingsNote)
							.end()
							.find('.alertInfo')
							.alert(personViewModalAlertSettingsInfo)
							.end()
							.find('.alertSuccess')
							.alert(personViewModalAlertSettingsSuccess)
							.end()
							.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
							.alert(personViewModalAlertSettingsWarning);
						initiateWebLinkValidator();
					}
				},
				error: function () {
					console.log('Request to get modal contents error.');
					$.modal.close();
				}
			});

		}
	});
}
/* Handle enabling/disabling weblink add/save button */
function enableOrDisableWebLinkAddOrSaveButton() {
	'use strict';
	var webLinkHref = $('#webAddressInput').val(),
		webLinkTitle = $('#linkNameInput').val();
	/*	Add/Save button disabled whenever at least one of the fields is empty or just has non white spaces */
	if ((webLinkHref.length > 0) && (/\S/.test(webLinkHref)) && (webLinkTitle.length > 0) && (/\S/.test(webLinkTitle))) {
		/* Enable button */
		$('.webLinkSaveButton').removeAttr('disabled');
	} else {
		/* Disable button */
		$('.webLinkSaveButton').attr('disabled', 'disabled');
	}
}
/* Add or Save a person webLink */
function saveWebLink(weblinkId) {
	'use strict';
	/* Disable button to avoid duplicates */
	$('.webLinkSaveButton').attr('disabled', 'disabled');
	var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/saveweblink';
	var weblinkHref = $('#webAddressInput').val(),
		weblinkTitle = $('#linkNameInput').val();
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		data: {
			webLinkId: weblinkId,
			webLinkHref: weblinkHref,
			webLinkTitle: weblinkTitle
		},
		success: function (data) {
			if (data.result) {
				var webLinkIdItem = $('#' + data.webLinkId);
				/* Edit WebLink - edit the node without forcing a reload of the page content */
				if (webLinkIdItem.length > 0) {
					var $webLink = webLinkIdItem.find('.webLinkHref');
					if ($webLink.length > 0) {
						$webLink
							.attr('href', weblinkHref)
							.text(weblinkHref);
					}
					webLinkIdItem.find('.webLinkTitle').text(weblinkTitle);
					/* change icon if the icon has changed after the update */
					var webLinkIcon = webLinkIdItem.find('.webLinkIcon');
					if (data.isAncestryWebLink) {
						if (!webLinkIcon.hasClass('iconAcom')) {
							webLinkIcon.removeClass('iconWebLink');
							webLinkIcon.addClass('iconAcom');
						}
					} else {
						if (!webLinkIcon.hasClass('iconWebLink')) {
							webLinkIcon.removeClass('iconAcom');
							webLinkIcon.addClass('iconWebLink');
						}
					}
					/* close the modal & callouts */
					closeCallouts();
					$.modal.close();
				}
				/* Add WebLink  - glue reload after adding a weblink */
				else {
					closeCallouts();
					$.modal.close();
					if (window.personScreenType('smart-phone')) {
						window.glue.reload({ "responsiveTab": "sources" });
					} else {
						window.glue.reload();
					}
				}
			}
		}
	});
}
/* Remove a person event */
function removeWebLink(webLinkId) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/weblink/' + webLinkId + '/removeweblink';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			/* Update removal items */
			if (data.result) {
				/* Remove WebLink node without forcing a reload of the page content */
				var webLinkIdItem = $('#' + webLinkId);
				if (webLinkIdItem.length > 0) {
					webLinkIdItem.hide();
				}
				/* close the modal & callouts */
				closeCallouts();
				$.modal.close();
			}
		}
	});
}
/* After Belay */
function afterBelay(target) {
	'use strict';
	if (target) {
		target = $('#' + target);
	} else {
		target = $('.' + $('.factItemSelected').attr('id'));
	}
	target.addClass('cardOutline2 factItemFocused');
}
/* Before Belay */
function beforeBelay(animate, factItem) {
	'use strict';
	if (factItem) {
		factItem
			.addClass('bgColor2 bgDark cardSelected factItemFocused factItemSelected')
			.find('.cardActions a')
			.addClass('bgDark');
	}
	$('#ropebagFacts').belay({
		'animate': (!animate) ? false : animate,
		'callback': afterBelay,
		'ropes': window.personScreenType('smart-phone') ? 'no' : 'yes',
		'selectors': [$('.factItemSelected').attr('id')],
		'stroke': '#897ea2' /* Fuji 2 */
	});
}
function setClassStyle(fmList) {
	if (fmList.length < 2) {
		return;
	}
	var nClass = ' si' + fmList[0];
	for (var i = 1; i < fmList.length; i = i + 1) {
		var id = '#family' + fmList[i];
		var $sel = $(id).select();
		if ($sel.length > 0) {
			$sel.addClass(nClass);
		}
	}
}
function setFamilyMemberSources(jsonResp) {
	if (typeof (jsonResp) != 'undefined' && typeof (jsonResp.FamilyMemberData) != 'undefined' && jsonResp.FamilyMemberData.length > 0) {
		for (var ii = 0; ii < jsonResp.FamilyMemberData.length; ii = ii + 1) {
			var fmData = jsonResp.FamilyMemberData[ii];
			if (typeof (fmData) == 'undefined') {
				break;
			}
			var fmList = fmData.split(',');
			setClassStyle(fmList);
		}
	}
}
function updateFamilyMemberStyles() {
	if (typeof (familyMembersSources) != 'undefined') {
		setFamilyMemberSources(familyMembersSources);
	}
	else if (typeof (PersonResearch.personIds) != 'undefined' && PersonResearch.personIds != '') {
		/* get the personIds, and setup the Family Members with sources lines Data */
		$.ajax({
			cache: false,
			url: getPersonAjaxUrlPrefix() + '/tree/' + PersonResearch.treeId + '/person/' + PersonResearch.personId + '/getfamilymembersourcedata?personIds=' + PersonResearch.personIds,
			type: 'GET',
			dataType: 'json',
			contentType: 'application/json',
			jsonpCallback: 'handleJSON',
			success: function (response) {
				var fmSources = JSON.parse(response);
				setFamilyMemberSources(fmSources);
				familyMembersSources = fmSources;
			},
			error: function (msg) {
			}
		})
	}
}
/* On Ready */
$(function () {
	'use strict';
	var doubleClick = false,
		enterPressed = false;
	/* Edit weblink modal */
	function editWebLinkModal(webLinkItem) {
		$('<div>').modal({
			'showLoading': true,
			'$trigger': $('#' + webLinkItem.attr('id')),
			'width': '510',
			'onOpen': function ($this) {
				var url = getPersonAjaxUrlPrefix() + '/tree/' + PersonCard.treeId + '/person/' + PersonCard.personId + '/editweblink';
				$.ajax({
					type: 'GET',
					url: url,
					cache: false,
					timeout: 20000,
					data: {
						webLinkId: webLinkItem.attr('id'),
						webLinkHref: convertHTML(webLinkItem.find('.webLinkHref').text()),
						webLinkTitle: convertHTML(webLinkItem.find('.webLinkTitle').text())
					},
					success: function (data) {
						$.modal.showLoading(false);
						if (data.result) {
							/* Modal Data and Initialize Alerts */
							$this
								.html(
								'<div class="modalHasTitle">' +
								'<div class="modalHeader">' +
								'<h4 class="modalTitle">' + PersonResearch.text.webLink + '</h4>' +
								'</div>' +
								data.html +
								'</div>'
								)
								.find('.alertNote')
								.alert(personViewModalAlertSettingsNote)
								.end()
								.find('.alertInfo')
								.alert(personViewModalAlertSettingsInfo)
								.end()
								.find('.alertSuccess')
								.alert(personViewModalAlertSettingsSuccess)
								.end()
								.find('.alert:not(.alertNote):not(.alertInfo):not(.alertSuccess)')
								.alert(personViewModalAlertSettingsWarning);
							initiateWebLinkValidator();
							/* Remove Weblink Callout */
							$('.modalWebLinks .removeButton').callout({
								'classes': 'calloutRemoveWeblink',
								'content': '#removeWeblinksCalloutDomContent',
								'position': 'top',
								'style': 'dark'
							});
						} else {
							console.log('Data error');
							$.modal.close();
						}
					},
					error: function () {
						console.log('Request to get modal contents error.');
						$.modal.close();
					}
				});
			}
		});
	}
	/* Function to call either the new Node Version of Fact Edit Modal or the old one */
	function doFactEditModal(persondata, assertionId, haslsOptions, tabactivate, contentactivate, apNewPid, seData, iscreateevent, showtabs) {
		if (window.PersonCard !== undefined && window.PersonCard.showNodeFEM !== undefined && window.PersonCard.showNodeFEM === 'True') {
			$('<div>').modal({
				'onClose': function ($this) {
					PersonResearch.openOnLoadTab = 0;
				},
				'onOpen': function ($this) {
					/* make an ajax request to get the modal contents */
					var femContentUrl = persondata.factEditContentUrl.replace("assertionId", assertionId);
					femContentUrl += "?activeIndex=" + PersonResearch.openOnLoadTab;
					$.ajax({
						type: 'GET',
						url: femContentUrl,
						cache: false,
						timeout: 5000,
						success: function (data) {
							if (data.html) {
								$this.html(data.html);
								$.modal.showLoading(false);
							}
						},
						error: function () {
							console.log('Request to get modal contents error.');
							$.modal.close();
						}
					});
				},
				'showLoading': true,
				'$trigger': $('.factItemSelected .cardAction'),
				'width': 720
			});
		} else {
			newFactEditModal(persondata, assertionId, haslsOptions, tabactivate, contentactivate, apNewPid, seData, iscreateevent, showtabs, window.PersonCard.doFEMLogging);
		}
	}
	/* Toggle Name and Gender */
	function toggleNameAndGender() {
		var $this = $(this),
			$factItemSelected = $('.factItemSelected');
		if ($html.hasClass('pFShowingNameAndGender')) {
			/* Hide Name and Gender */
			$html.removeClass('pFShowingNameAndGender');
			if ($factItemSelected.length) {
				if ($factItemSelected.hasClass('factItemName') || $('.factItemSelected').hasClass('factItemGender')) {
					$factItemSelected.trigger('belay.off');
				} else {
					if ($('.factItemFocused').length) {
						beforeBelay();
					}
				}
			}
			$this.attr('aria-expanded', 'false');
		} else {
			/* Show Name and Gender */
			$html.addClass('pFShowingNameAndGender');
			if ($('.factItemFocused').length) {
				beforeBelay();
			}
			$this
				.attr('aria-expanded', 'true')
				.closest('section')
				.find('#researchListFacts > li:first-child .card')
				.focus();
		}
	}
	/* Person Page Facts Events */
	$('.personPageFacts')
		.off('click')
		.off('dblclick')
		.on('belay.on', '.connectFact', function () {
			var factItem = $(this);
			if (!factItem.hasClass('factItemWeblink')) {
				beforeBelay(false, factItem);
			}
		})
		.on('belay.off', '.connectFact', function () {
			$('.factItemFocused')
				.removeClass('bgColor2 bgDark cardSelected factItemFocused factItemSelected cardOutline2')
				.find('.cardActions a')
				.removeClass('bgDark');
			$('#ropebagFacts').empty();
		})
		.on('mousedown', '.cardHasSelectAction.connectFact.factItemSelected', function (e) {
			e.preventDefault();
		})
		.on('keydown', '.cardHasSelectAction.connectFact.factItemSelected', function (e) {
			if (e.which === 13 || e.which === 32) {
				e.preventDefault();
				if (enterPressed === false) {
					$(this).trigger('click.off');
				} else {
					$(this).trigger('dblclick');
				}
			}
		})
		.on('keydown', '.cardHasSelectAction.connectFact:not(.factItemSelected)', function (e) {
			if (e.which === 13 || e.which === 32) {
				e.preventDefault();
				enterPressed = true;
				$(this).trigger('click.on');
				setTimeout(function () {
					enterPressed = false;
				}, 300);
			}
		})
		.on('click.off', '.cardHasSelectAction.connectFact.factItemSelected', function (e) {
			e.preventDefault();
			var factItem = $(this);
			setTimeout(function () {
				if (doubleClick === false) {
					if (factItem.hasClass('factItemFamily')) {
						var href = factItem.attr('href');
						window.location.href = href;
					} else {
						factItem.trigger('belay.off');
					}
				}
			}, 300);
		})
		.on('click.on', '.cardHasSelectAction.connectFact:not(.factItemSelected)', function (e) {
			e.preventDefault();
			var factItem = $(this),
				isFamilyCard = factItem.hasClass('factItemFamily');
			doubleClick = false;
			if ((isFamilyCard && window.personScreenType('smart-phone')) || !isFamilyCard || enterPressed || (factItem.find('.cardAction').css("visibility") === "hidden")) {
				$('.connectFact.factItemSelected').trigger('belay.off');
				if (!factItem.hasClass('factItemWeblink')) {
					beforeBelay(true, factItem);
				}
			} else {
				setTimeout(function () {
					if (doubleClick === false) {
						var href = factItem.attr('href');
						window.location.href = href;
					}
				}, 300);
			}
		})
		.on('dblclick doubletap', '.cardHasSelectAction.connectFact', function () {
			doubleClick = true;
			setTimeout(function () {
				doubleClick = false;
			}, 1000);
			var factItem = $(this);
			if (factItem.hasClass('factItemWeblink')) {
				editWebLinkModal(factItem);
			} else {
				var factsSection = factItem.closest('.factsSection'),
					assertionId = factItem.attr('id').replace('fi', ''),
					sourceid = factItem.attr('id').replace('si', '');
				if (factsSection.hasClass('factsSectionFacts')) {
					var allowEditOrView = factItem.find('.allowEditOrView').val();
					if (allowEditOrView === 'true') {
						var hasLifeStoryOptions = factItem.find('.hasLifestoryOptions').val();
						if (assertionId === 'UnknownGender') {
							assertionId = '99';
						}
						doFactEditModal(PersonResearch, assertionId, hasLifeStoryOptions, '0', 'tabContent0', '', '', false, true);
					}
				}
				if (factsSection.hasClass('factsSectionSources')) {
					var formId = factItem.attr('id');
					sourceid = (sourceid.indexOf('0x') === -1) ? sourceid : '0';
					if (sourceEditModal !== undefined) {
						sourceEditModal(PersonResearch.treeId, PersonResearch.personId, sourceid, formId);
					}
				}
				if (factsSection.hasClass('factsSectionFamily')) {
					var href = factItem.attr('href'),
						matchPId = href.match(/person\/(-?\d+)/),
						matchTId = href.match(/tree\/(\d+)/),
						dataPId = matchPId[1],
						dataTId = matchTId[1];
					quickEdit(dataTId, dataPId, factItem);
				}
			}
		})
		.on('keydown', '.cardAction', function (e) {
			if (e.which === 13 || e.which === 32) {
				e.preventDefault();
				e.stopImmediatePropagation();
				$(this)
					.closest('.connectFact')
					.trigger('dblclick');
			}
		})
		.on('click', '.cardAction', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			$(this)
				.closest('.connectFact')
				.trigger('dblclick');
		})
		.on('keydown', '.cardEmpty[onclick]', function (e) {
			if (e.which === 13 || e.which === 32) {
				e.preventDefault();
				$(this)
					.get(0)
					.click();
			}
		})
		.on('click', '.optionsButtonSources.iconAfter', function () {
			/* Add Source Callouts */
			var $this = $(this);
			if (!$this.data('calloutInstance')) {
				$this.callout({
					'classes': 'calloutMenu sourceOptionsCallout',
					'content': PersonResearch.menu.sources.addSourceCallout,
					'style': 'dark'
				});
				$this.callout('open');
			}
		})
		.on('click', '.optionsButtonFamily', function () {
			/* Add Family Callouts */
			var $this = $(this);
			if (!$this.data('calloutInstance')) {
				var addFamilyCallout = $('#noDisplayAddFamilyCallout').html();
				$this.callout({
					'classes': 'calloutMenu familyOptionsCallout',
					'content': addFamilyCallout,
					'style': 'dark'
				});
				$this.callout('open');
			}
		})
		.on('click', '.personClick', function (e) {
			/* This is a link to another person page. We don't want the card to receive a click. */
			e.stopPropagation();
		});
	/* Fact events */
	$('.factsSectionFacts')
		.off('click')
		.on('click', '.toggleNameAndGenderButton', function () {
			toggleNameAndGender();
		})
		.on('click', '.editFact', function (event) {
			if ($(this).closest('.factItem').attr('id').length > 0) {
				var assertionId = $(this).closest('.factItem').attr('id').replace('fi', ''),
					allowEditOrView = $(this).closest('.factItem').find('.allowEditOrView').val();
				if (allowEditOrView === 'true') {
					var hasLifeStoryOptions = $(this).closest('.factItem').find('.hasLifestoryOptions').val();
					if (assertionId === 'UnknownGender') {
						assertionId = '99';
					}
					doFactEditModal(PersonResearch, assertionId, hasLifeStoryOptions, '0', 'tabContent0', '', '', false, true);
				}
			}
			event.stopPropagation();
		})
		.on('keypress', '.mediaItemsCount, .sourceCitationsCount', function (e) {
			/* Media and Citations Count */
			e.stopPropagation();
			if (e.which === 13 || e.which === 32) {
				e.preventDefault();
				$(this)
					.closest('.connectFact')
					.trigger('dblclick');
			}
		})
		.on('click', '.FocusPerson', function (e) {
			e.stopPropagation();
		})
		.on('click', '.sourceCitationsCount', function () {
			/* clicking on sources count should open fact edit modal and go to the "Source Citations" tab */
			PersonResearch.openOnLoadTab = 2;
			$(this)
				.closest('.connectFact')
				.trigger('dblclick');
		})
		.on('click', '.mediaItemsCount, .factThumb', function () {
			/* clicking on media count should open fact edit modal and go to the "Media" tab */
			PersonResearch.openOnLoadTab = 1;
			$(this)
				.closest('.connectFact')
				.trigger('dblclick');
		});
	/* Source events */
	$('.factsSectionSources')
		.off('click')
		.on('click', '.editFact', function () {
			if ($(this).closest('.factItem').attr('id').length > 0) {
				var formId = $(this).closest('.factItem').attr('id'),
					sourceid = formId.replace('si', ''),
					sourceId = (sourceid.indexOf('0x') === -1) ? sourceid : '0';
				if (sourceEditModal !== undefined) {
					sourceEditModal(PersonResearch.treeId, PersonResearch.personId, sourceId, formId);
				}
			}
		})
		.on('click dblclick', '.factItemSource a', function (event) {
			/* Don't connect lines when clicking on a source and just go to the source url */
			event.stopPropagation();
		})
		.on('click dblclick', '.factItemWeblink a', function (event) {
			event.stopPropagation();
		});
	/* Extend PersonResearch object (PersonResearch object defined in PersonResearch.ascx) to include data about what evidence item was selected. */
	$.extend(PersonResearch, { selected: null });
	/* Check Customizing (Toggeling events on and off from callouts) */
	if ($('#callout > div[id*="showFacts"].open').length || $('#calloutWrap-printFriendlyCustomizeBtn.open').length) {
		factsTogglingCheckMark = true;
	}
	/* Remove callouts that were part of the previous glue. */
	$('#callout > div[id*="addSource"]').remove();
	$('#callout > div[id*="addFamily"]').remove();
	$('#callout > div[id*="showFacts"]').remove();
	/* Print Friendly */
	if ($html.hasClass('printFriendly')) {
		/* Swap columns */
		$('.factsSectionFamily').insertAfter($('.factsSectionFacts'));
		/* Check Notes and Comments */
		checkNotesAndComments();
	}
	/* Show Facts Callouts (Need to be created on ready rather than on click) */
	$('#showFactsMobile').callout({
		'classes': 'calloutMenu factsOptionsCallout',
		'content': PersonResearch.menu.facts.showFactsCallout,
		'style': 'dark'
	});
	$('#showFactsDesktop').callout({
		'classes': 'calloutMenu factsOptionsCallout',
		'content': PersonResearch.menu.facts.showFactsCallout,
		'style': 'dark'
	});
	/* Customize Print callout */
	$('.pageHeaderFacts #printFriendlyCustomizeBtn').callout({
		'classes': 'calloutPrintFriendlyCustomize calloutMenu',
		'content': PersonResearch.callouts.print,
		'onOpen': function () {
			closeMyCanvasGuidance();
			/* Name and Gender */
			if ($html.hasClass('pFShowingNameAndGender')) {
				$('#printNameAndGender')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			} else {
				$('#printNameAndGender')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			}
			/* Siblings */
			if ($html.hasClass('pFShowingSiblings')) {
				$('#printSiblings')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			} else {
				$('#printSiblings')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			}
			/* Notes */
			if ($html.hasClass('pFShowingNotes')) {
				$('#printNotes')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			} else {
				$('#printNotes')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			}
			/* Comments */
			if ($html.hasClass('pFShowingComments')) {
				$('#printComments')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			} else {
				$('#printComments')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			}
			/* Facts */
			if ($html.hasClass('pFNoFacts')) {
				$('#printFacts')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			} else {
				$('#printFacts')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			}
			/* Family */
			if ($html.hasClass('pFNoFamily')) {
				$('#printFamily')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			} else {
				$('#printFamily')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			}
			/* Sources */
			if ($html.hasClass('pFNoSources')) {
				$('#printSources')
					.removeClass('calloutMenuChecked')
					.addClass('calloutMenuUnchecked');
			} else {
				$('#printSources')
					.removeClass('calloutMenuUnchecked')
					.addClass('calloutMenuChecked');
			}
		},
		'onAfterOpen': function () {
			/* Print events */
			$('.calloutPrintFriendlyCustomize')
				.off('click')
				.on('click', '#printFacts', function () {
					/* Toggle Facts */
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
					$html.toggleClass('pFNoFacts');
				})
				.on('click', '#printFamily', function () {
					/* Toggle Family */
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
					$html.toggleClass('pFNoFamily');
				})
				.on('click', '#printNameAndGender', function () {
					/* Toggle Name and Gender */
					toggleNameAndGender();
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
				})
				.on('click', '#printSiblings', function () {
					/* Toggle Siblings */
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
				})
				.on('click', '#printSources', function () {
					/* Toggle Sources */
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
					$html.toggleClass('pFNoSources');
				})
				.on('click', '#printNotes', function () {
					/* Toggle Notes */
					$html.toggleClass('pFShowingNotes');
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
				})
				.on('click', '#printComments', function () {
					/* Toggle Comments */
					$html.toggleClass('pFShowingComments');
					$(this).toggleClass('calloutMenuUnchecked calloutMenuChecked');
				});
		},
		'style': 'dark'
	});
	if (factsTogglingCheckMark === true) {
		if ($html.hasClass('printFriendly')) {
			$('#printFriendlyCustomizeBtn').callout('open');
		} else {
			if (window.personScreenType('smart-phone')) {
				$('#showFactsMobile').callout('open');
			} else {
				$('#showFactsDesktop').callout('open');
			}
		}
		/* Reset to false */
		factsTogglingCheckMark = false;
	}
	/* Show siblings by default when adding a sibling */
	if (PersonCard.isAddSibling) {
		PersonCard.isAddSibling = false;
		$html.addClass('pFShowingSiblings');
	}
	/* If we have a notify object from a merge record process (see the notify section at the bottom of PersonCard.ascx) */
	if (notifyRecordObject !== null) {
		var record = $('.record_' + notifyRecordObject.data.databaseId + '_' + notifyRecordObject.data.recordId);
		PersonResearch.selectOnLoad = record.attr('id').replace('si', '');
		PersonResearch.loadActionId = record.attr('id');
	}
	updateFamilyMemberStyles();
	/* Select item load actions */
	var loadActionId = PersonResearch.loadActionId,
		selectOnLoad = PersonResearch.selectOnLoad,
		openOnLoad = PersonResearch.openOnLoad;
	if ((selectOnLoad !== '0') || (openOnLoad !== '0')) {
		var $item = $('#' + loadActionId + '.connectFact');
		$(window).scrollTop($item.offset.top);
		if ($item.length > 0) {
			if (window.personScreenType('smart-phone')) {
				initializeMobileTabs(1); /* Return to sources tab */
			}
			if (openOnLoad !== '0') {
				$item
					.trigger('click.on')
					.trigger('dblclick');
			} else {
				$item.trigger('click.on');
			}
		}
	}

});